var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DaySelector',{on:{"select":_vm.load}}),_c('div',{staticClass:"s-vstack"},[_c('List'),_c('CountBySignin')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }